import script from "./create.vue?vue&type=script&setup=true&lang=ts"
export * from "./create.vue?vue&type=script&setup=true&lang=ts"

import "./create.vue?vue&type=style&index=0&id=43753037&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43753037"]])

export default __exports__